/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React, { lazy, Suspense } from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';

const NotFound = lazy(() => import('../errors/404'));
const Rcn = lazy(() => import('../logins/Rcn'));

import '../styles/main.scss';

class Main extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.validateParam('failureRedirect');
    this.validateParam('redirect_uri');
  }

  validateParam = (param) => {
    const params = new URLSearchParams(location.search);
    const queryParm = params.get(param);
    if (queryParm && !queryParm.match(/^(?:(?:https?|mailto|ftp|tel|file|sms):|[^&:/?#]*(?:[/?#]|$))/gi)) {
      console.warn(`BLOCKED INSECURE QUERY PARAM - ${param}`);
      params.set(param, '#');
      history.replaceState(null, '', `?${params}${location.hash}`);
    }
  }

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Suspense fallback={<br/>}>
            <Route path="/rcn" component={Rcn}/>
          </Suspense>
          <Route path="*" component={NotFound}/>
        </Switch>

      </BrowserRouter>
    );
  }
}

export default Main;
